import React, { useCallback, useContext, useMemo } from "react";
import { StringUtil } from "@eres/core";
import pptyCoString from "@my-dld/assets/strings/property_cooccupants";
import Strings from "@my-dld/assets/strings";
import { CoOccupantPropertyInfo } from "@eres/ejari-api/Entity/co_occupants";

export type COMode = "contract" | "property";

const PCStrings = StringUtil.lvString( pptyCoString );

export function getCOString( mode: COMode, k: keyof typeof Strings ): string {
	if ( mode === "property" ) {
		let v = ( PCStrings as any )[ k ];
		if ( v != null ) return v;
	}
	return Strings[ k ];
}

export interface ICOContext {
	info: CoOccupantPropertyInfo;
	mode: COMode;
	getString: ( k: keyof typeof Strings ) => string;
	propertyTitle?: () => string;
}

export const defCOContext: ICOContext = {
	mode: "contract",
	getString: ( k: keyof typeof Strings ) => Strings[ k ],
	info: {} as CoOccupantPropertyInfo,
	propertyTitle: () => "",
};
const COContext = React.createContext( defCOContext );

export default COContext;

const defaultState: ICOContext = defCOContext;
export { defaultState as DefaultState };


export function COContextWrapper( props: React.PropsWithChildren<{ mode: COMode, info: CoOccupantPropertyInfo, propertyTitle: () => string }> ) {
	let { children, mode, info, propertyTitle } = props;
	const getString = useCallback( ( k: keyof typeof Strings ) => {
		return getCOString( mode, k );
	}, [ mode ] );
	const ocx = useMemo( () => {
		return {
			mode: mode,
			getString,
			info,
			propertyTitle,
		};
	}, [ mode, getString, info, propertyTitle ] );
	return (
		<COContext.Provider value={ ocx }>
			{ children }
		</COContext.Provider>
	);
}

export function useCoContext() {
	return useContext( COContext );
}
